module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/april-7d5fb2f6d7d533ae33fef7d14857df32.png";